import { motion } from 'framer-motion';
import Button from '~/commonComponents/Button';
import { Column } from '~/commonComponents/Column';
import { Text } from '~/commonComponents/Text';
import documentTextIcon from '~/images/document-text-white.svg';
import { Colors } from '~/themes/colors';
import browserHistory from '~/browserHistory';
import { routes } from '~/routes';
import { useOfficeTnCConsent } from '~/hooks/useOfficeTnCConsent';

export function OfficeTnCConsentPopup() {
  const { isActive, shouldShow, consentContent } =
    useOfficeTnCConsent();

  if (!shouldShow || !isActive) {
    return null;
  }

  return (
    <button type="button" style={{ all: 'unset' }}>
      <div
        className="modal"
        data-testid="office-tnc-consent-modal"
        style={{
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          position: 'fixed',
        }}
      >
        <motion.div
          data-testid="office-tnc-consent-popup"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          onClick={(event) => event.stopPropagation()}
        >
          <Column
            alignItems="center"
            width={500}
            maxHeight="90vh"
            backgroundColor={Colors.white}
            borderRadius={12}
            paddingLeft={35}
            paddingRight={35}
            paddingTop={50}
            paddingBottom={50}
            overflow="auto"
            boxShadow="0px 2px 3px 0px rgba(0,0,0,0.15), 0px 6px 10px 2px rgba(0,0,0,0.15)"
          >
            <Text
              bold
              fontSize={18}
              color="neutral_600"
              textAlign="center"
              marginBottom={16}
            >
              {consentContent?.header}
            </Text>

            <Text
              fontSize={16}
              color="neutral_600"
              textAlign="center"
              marginBottom={32}
            >
              {consentContent?.body}
            </Text>

            <Button
              type="button"
              Icon={documentTextIcon}
              style={{ width: 'auto', paddingLeft: 26, paddingRight: 26, marginTop: 0 }}
              text="Click here to view"
              size="small"
              dataCy="office-tnc-accept-button"
              onClick={() => browserHistory.push(routes.termsAndConditions)}
            />
          </Column>
        </motion.div>
      </div>
    </button>
  );
}
